import { StarLite } from '@apeiron/star'
import { DEFAULT_ANIMATE_SHORT_DURATION } from '@apeiron/temp'
import { MuiLoading } from '@apeiron/ui'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import ListEmptyState from '@src/components/share/list/ListEmptyState'
import StarCard from '@src/components/stars/cards/StarCard'
import ENV_CONFIG from '@src/config'
import { ROUTE } from '@src/constants/route'
import * as R from 'ramda'
import { FC } from 'react'

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 20px;
  ${props => props.theme.breakpoints.up('res1024')} {
    row-gap: 0px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    row-gap: 29px;
  }
`

const StyledMuiLoading = styled(MuiLoading)`
  position: absolute;
  top: calc(40% - 22px);
  left: calc(50% - 22px);
`

const StyledStarCard = styled(StarCard)`
  & {
    transition: transform ${DEFAULT_ANIMATE_SHORT_DURATION}ms ease-out;
  }
  &:hover {
    transform: translateY(-5px);
  }
`

const StarList: FC<Props> = (props: Props) => {
  const {
    cardClassName,
    className,
    emptyDescription,
    emptyRecommendation,
    enableLink = true,
    loading = true,
    showExplain,
    stars,
    onRenderURL,
    onItemClick
  } = props

  return (
    <Container className={className}>
      {loading ? (
        <StyledMuiLoading loading />
      ) : R.isEmpty(stars) ? (
        <ListEmptyState
          description={emptyDescription}
          buyURL={emptyRecommendation ? ROUTE.MARKETPLACE_STAR_LIST : ''}
          rentURL={
            emptyRecommendation ? ENV_CONFIG.EXTERNAL_URL.LOOTRUSH.STAR : ''
          }
        />
      ) : (
        <>
          {R.map(
            (star: StarLite) => (
              <Box key={star.id}>
                <StyledStarCard
                  className={cardClassName}
                  enableLink={enableLink}
                  showExplain={showExplain}
                  showId
                  star={star}
                  onRenderURL={onRenderURL}
                  onClick={onItemClick}
                />
              </Box>
            ),
            stars
          )}
        </>
      )}
    </Container>
  )
}

type Props = {
  cardClassName?: string
  className?: string
  enableLink?: boolean
  emptyRecommendation?: boolean
  emptyDescription: string
  loading: boolean
  showExplain?: boolean
  stars: StarLite[]
  onRenderURL?: (star: StarLite) => string
  onItemClick?: (star: StarLite) => void
}

export default StarList
